import { Button, Flex, HStack, Icon, Text } from '@chakra-ui/react'
import { faExclamationTriangle, faRefresh } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { useRouteError } from 'react-router'

export const GlobalErrorBoundary = () => {
  const error = useRouteError()

  useEffect(() => {
    Sentry.captureException(error)
    console.error(error)
  }, [error])

  return (
    <Flex direction="column" align="center" justify="center" minH="100vh" gap={6} p={8}>
      <Icon as={FontAwesomeIcon} icon={faExclamationTriangle} boxSize={12} color="red.500" />
      <Text fontSize="2xl" fontWeight="medium" textAlign="center">
        Došlo k neočekávané chybě
      </Text>
      <Text maxW="40ch" textAlign="center" color="gray.600">
        Omlouváme se, ale v aplikaci došlo k neočekávané chybě.
        Zkuste to prosím znovu.
      </Text>
      <Button colorScheme="gray" size="lg" onClick={() => window.location.reload()}>
        <HStack>
          <Icon as={FontAwesomeIcon} icon={faRefresh} />
          <span>Znovu načíst</span>
        </HStack>
      </Button>
      <Text maxW='30ch' textAlign='center' color='gray.600'>
        V případě, že problém přetrvává, kontaktujte prosím podporu.
      </Text>
    </Flex>
  )
}
